import React from 'react';
import { useTranslation } from 'react-i18next';
import getTouchposeVideo from '../../../assets/video/get-touchpose.mp4';
import VideoPlayer from './VideoPlayer';

const GetTouchposeDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary">
      <h2
        id="get-touchpose"
        className="font-display text-[24px] font-extrabold text-content-primary mb-[24px] tracking-[-0.4px]"
      >
        {t('docs.getTouchpose.title')}
      </h2>
      <p className="text-[14px] leading-[1.75] text-content-secondary mb-[24px]">
        {t('docs.getTouchpose.description')}
      </p>

      <VideoPlayer src={getTouchposeVideo} />
    </article>
  );
};

export default GetTouchposeDoc;
